import React, { useEffect, useState } from 'react';
import { push, replace } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { SmartContainer } from '../../../styles/Containers';
import { StyledCircularProgress } from '../../../styles/matieralui/Progress';
import { AssetViewer } from './AssetViewer';
import { getAsset } from './redux/assets.actions';
import { FullAssets } from './redux/assets.selectors';
import { CurrentNetwork } from '../../../redux/Network/network.selectors';
import { useActiveItem } from '../../services/CaptureCollabService';
import { StyledCaptureCollabIcon } from '../../../assets/CaptureCollabIconSVG';
export const PageAsset = () => {
    // New Modal
    const dispatch = useDispatch();
    const store = FullAssets();
    const { assetId } = useParams();
    const [activeAsset, setActiveAsset] = useState(null);
    const [lastRoute, setLastRoute] = useState(null);
    const history = useHistory();
    const location = useLocation();
    const thisNetwork = CurrentNetwork();
    const { activeLoading, activeItem } = useActiveItem({ id: assetId, model: 'Asset', selector: FullAssets, getAction: getAsset })



    // useEffect(() => {
    //     console.log("Get The ASset From the Database")
    //     dispatch(getAsset(assetId))
    // }, [assetId]);

    // useEffect(() => { if (store?.activeItem) setActiveAsset(store.activeItem); }, [store.activeItem, store])


    useEffect(() => {
        if (location?.state?.from) setLastRoute(location.state.from);
    }, [])
    const handleClose = () => {
        history.goBack();
    }

    const setAssetByIndex = (index) => {
        if (!store?.items?.rows[index]) return;
        dispatch(replace(`/asset/${store?.items?.rows[index].id}`))
    }
    return (
        <SmartContainer>
            {activeLoading === true && (<SmartContainer flex align="center" justify="center" minHeight="50vh"><StyledCaptureCollabIcon /></SmartContainer>)}
            {(activeItem && activeLoading !== true) && (<AssetViewer onClose={handleClose} asset={activeItem} setAssetByIndex={setAssetByIndex} />)}
        </SmartContainer>
    )
}